import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        formContainer: {
            padding: theme.spacing(1),
            cursor: 'auto',
            background: theme.palette.secondary[50],
        },
    }
})

export default useStyles
